export default "__VITE_ASSET__C6y6$Hjd__"